import React from 'react';
import Tab from 'apollo-react/components/Tab';
import StarSolid from 'apollo-react-icons/StarSolid';
import styles from './StyledTabs.module.css';

const StarTab = React.forwardRef(
  ({ label, isActive, showStar = true, hasError, ...tabProps }, ref) => (
    <Tab
      {...tabProps}
      ref={ref}
      label={
        <span className={styles.tabLabelContent}>
          {showStar && isActive && <StarSolid className={styles.tabStarIcon} />}
          {label}
          {hasError && <span className={styles.tabErrorIndicator}>!</span>}
        </span>
      }
    />
  )
);

StarTab.displayName = 'StarTab';

export default StarTab;
